import React from "react";

//Component takes in 4 props
//props 1 optional name: count type: number
//Example count ={array.length||0}

// props 2 optional the Header Info as string
//Example  HeaderInfo="No Linked Accounts"

//props 3, optional propsCounterStyle Style object that will overide all style
//style object should be in this format to work

//style = { main: {"color":"red"}, info :{...}}

const defaultStyles = {};

const defaultInfo = {
  color: "#5B616B",
  fontWeight: "bold",
  lineHeight: "17px",
  fontSize: "15px",
  textTransform: "uppercase",
  fontFamily:
    "Source Sans Pro, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
};

export default function Counter(props) {
  let { count, label } = props;
  const { Main, info } = { ...props.CounterStyle };
  return (
    <div className="default-main" style={Main ? Main : defaultStyles}>
      <p className="default-info" style={info ? info : defaultInfo}>
        <strong>{count}</strong> {label}
      </p>
    </div>
  );
}
